import { Box, Button, Typography, Paper, Link } from '@mui/material';
import { useCookieConsent } from '../context/CookieContext';

const CookieConsent = () => {
  const { showBanner, acceptAll, acceptNecessary, openSettings } = useCookieConsent();

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(5px)'
      }}
    >
      <Paper
        elevation={8}
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          p: 3,
          backgroundColor: 'white'
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            We value your privacy
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
            By clicking "Accept All", you consent to our use of cookies.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can customize your preferences by clicking "Cookie Settings" or accept only necessary cookies.{' '}
            <Link href="/privacy-policy" target="_blank" sx={{ textDecoration: 'underline' }}>
              Learn more
            </Link>
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1,
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant="outlined"
            onClick={openSettings}
            sx={{
              textTransform: 'none',
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                borderColor: 'primary.dark',
                backgroundColor: 'rgba(156, 39, 176, 0.04)'
              }
            }}
          >
            Cookie Settings
          </Button>
          <Button
            variant="outlined"
            onClick={acceptNecessary}
            sx={{
              textTransform: 'none',
              borderColor: 'grey.400',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'grey.600',
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            Necessary Only
          </Button>
          <Button
            variant="contained"
            onClick={acceptAll}
            sx={{
              textTransform: 'none',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark'
              }
            }}
          >
            Accept All
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default CookieConsent;
